const authRoutes = {
    AUTHENTICATION_PLATFORM_AUTHORIZE_V01: {
        URL: '/v0.1/authentication/platform/authorize',
        METHOD: 'POST'
    },
}

const paymentPagesRoutes = {
    PAYMENT_PAGES_FETCH: {
        URL: '/v1/payment-pages/fetch',
        METHOD: 'GET'
    },
    PAYMENT_PAGES_FEE_TYPES_FETCH: {
        URL: '/v1/payment-pages/fee-types/fetch',
        METHOD: 'GET'
    },
    PAYMENT_PAGES_FEE_TYPES_CALCULATE: {
        URL: '/v1/payment-pages/fee-types/calculate',
        METHOD: 'POST'
    },
}

const formEditorRoutes = {
    FORM_EDITOR_FORM_FIELDS_UPDATE: {
        URL: '/v1/form-editor/form-fields/update',
        METHOD: 'PATCH'
    },
}

const studentsRoutes = {
    STUDENTS_FETCH: {
        URL: '/v1/students/fetch',
        METHOD: 'GET'
    },
    STUDENTS_CREATE: {
        URL: '/v1/students/create',
        METHOD: 'POST'
    },
    STUDENTS_WRAPPER_CREATE: {
        URL: '/v1/students/wrapper',
        METHOD: 'POST'
    },
    STUDENTS_RECEIPT_FETCH: {
        URL: '/v1/students/receipt',
        METHOD: 'GET'
    },
}

const gileClassRoutes = {
    GILE_CLASSES_FETCH: {
        URL: '/v1/gile',
        METHOD: 'GET'
    },
}

const customerDetailsUpdateMobileRoutes = {
    CUSTOMER_DETAILS_UPDATE_MOBILE_PATCH: {
        URL: '/v1/customer/customer-details/update-mobile',
        METHOD: 'PATCH'
    },
}

const miscRoutes = {
    SESSION_FETCH: {
        URL: '/v1/misc/session/fetch',
        METHOD: 'GET'
    },
    SESSION_CREATE_POST: {
        URL: '/v1/misc/session/create',
        METHOD: 'POST'
    },
}

const workflow = {
    WORKFLOW_FETCH_DETAILS: {
        URL: '/v1/workflow/fetch/details',
        METHOD: 'POST'
    }
};

const emailVerification = {
    CHECK_EMAIL_POST: {
        URL: '/v1/verifications/check-email',
        METHOD: 'POST',
    },
    VERIFY_EMAIL_OTP_POST: {
        URL: '/v1/verifications/verify-otp',
        METHOD: 'POST',
    },
    RESEND_EMAIL_OTP_POST: {
        URL: '/v1/verifications/resend-otp',
        METHOD: 'POST',
    }
}

const wrapperRoutes = {
    WRAPPER_PG_FLOW_POST: {
        URL: '/v1/wrapper/pg-flow',
        METHOD: 'POST',
    },
    WRAPPER_ORDER_STATUS_GET: {
        URL: '/v1/wrapper/order-status',
        METHOD: 'GET',
    },
};

export const routes = {
    ...authRoutes,
    ...paymentPagesRoutes,
    ...formEditorRoutes,
    ...studentsRoutes,
    ...gileClassRoutes,
    ...customerDetailsUpdateMobileRoutes,
    ...miscRoutes,
    ...workflow,
    ...emailVerification,
    ...wrapperRoutes,
};